import React, { Suspense } from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import routerConfig, { isRedirect, isLazyComponent } from './router-config';

const MapRouter = () => {
  /**
   * PS： 解释一下为什么这里需要单独解构3次config。因为routerConfig存在3种类型，每一种类型严格定义。
   *
   *  1. 第一次解构是因为判断好了Redirect类型，path和redirect是一定存在config里面的，所以后续可以不用判空直接使用。
   *  2. ts会自动推导还剩下两种类型LazyComponent和非LazyComponent。如果直接解构出path, component，此时的component是存在两种类型的，
   *     所以在引用的时候需要判断lazy=true，并且再次声明它为ILazyRouterConfig。 所以我干脆像第一种一样，判断好以后再解构，就一定能够确定它就是LazyComponent
   *  3. 因为之前两种情况已经判断并且跳出了函数，所以剩下的component一定是普通的ComponentType
   *
   *  也许typescript可以在后续版本中优化好，一次解构就能达到目的。
   */
  return (
    <>
      {routerConfig.map((config) => {
        if (isRedirect(config)) {
          const { path, redirect } = config;
          return (
            <Route key={path} path={path}>
              <Redirect to={redirect} />
            </Route>
          );
        }
        if (isLazyComponent(config)) {
          const { path, component } = config;
          const LazyComponent = React.lazy(component);
          return <Route key={path} path={path} component={LazyComponent} />;
        }
        const { path, component } = config;
        return <Route key={path} path={path} component={component} />;
      })}
    </>
  );
};

const Router: React.FC = () => {
  return (
    <HashRouter>
      {/* 引入Suspense来支持懒路由：https://reactjs.org/docs/code-splitting.html  */}
      <Suspense fallback={<div />}>
        <Switch>
          <MapRouter />
        </Switch>
      </Suspense>
    </HashRouter>
  );
};

export default Router;
